module.exports = __webpack_public_path__ + "img/DE01693.2d82ee0d.png";